const SituacaoAgendamento = {
    ENVIAR_CONFIRMACAO : 'ENVIAR_CONFIRMACAO',
    CONFIRMAR_MANUALMENTE : 'CONFIRMAR_MANUALMENTE',
    AGUARDAR_CONFIRMACAO : 'AGUARDAR_CONFIRMACAO',
    CONFIRMAR : 'CONFIRMAR',
    EXAMES_EM_DIA : 'EXAMES_EM_DIA'
}

export default SituacaoAgendamento;